import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { lazy, Suspense, useEffect } from "react";
import { applyBranding, saveBranding } from "./utils/brandingManager";
import { useBranding } from "./context/BrandingContext";

const MainPpage = lazy(() => import("./pages/MainPpage"));
const PaymentDetails = lazy(() => import("./pages/PaymentDetails"));
const AppPaymentDetails = lazy(() => import("./pages/AppPaymentDetails"));
const PaymentOrder = lazy(() => import("./pages/PaymentOrder"));
function App() {
  const { setBranding } = useBranding();
  useEffect(() => {
    const DEFAULT_TITLE = "Secure Pay";
    const DEFAULT_FAVICON = "/favicon.png";

    const resetBranding = () => {
      localStorage.removeItem("branding");

      applyBranding({
        title: DEFAULT_TITLE,
        favicon: DEFAULT_FAVICON,
      });
    };

    const getSettingsData = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_URL + "admin/paymentGatewayAccessSettings",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
            },
          },
        );

        const res = await response.json();

        // console.log(res);

        if (res?.status !== "success" || !res?.data?.length) {
          resetBranding();
          return;
        }

        const settings = res.data[0];

        // Safe title
        const projectTitle = settings?.paymentGatewayName?.trim()
          ? settings.paymentGatewayName
          : DEFAULT_TITLE;

        // Safe logo
        const logoUrl = settings?.paymentGatewayLogo
          ? process.env.REACT_APP_s3 + settings.paymentGatewayLogo
          : DEFAULT_FAVICON;

        const brandingData = {
          title: projectTitle,
          favicon: logoUrl,
        };

        // console.log("Title:", settings.paymentGatewayName);

        applyBranding(brandingData);
        saveBranding(brandingData);
        setBranding(brandingData);
      } catch (error) {
        console.log(error);

        resetBranding();
      }
    };

    getSettingsData();
  }, [setBranding]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={"Loading..."}>
              <MainPpage />
            </Suspense>
          }
        />
        <Route
          path="/payment-details/:orderId/:amount"
          element={
            <Suspense fallback={"Loading..."}>
              <PaymentDetails />
            </Suspense>
          }
        />
        <Route
          path="/app-payment-details/:orderId/:amount"
          element={
            <Suspense fallback={"Loading..."}>
              <AppPaymentDetails />
            </Suspense>
          }
        />
        <Route
          path="/payment-order/:paymentId"
          element={
            <Suspense fallback={"Loading..."}>
              <PaymentOrder />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
